let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jYGDv")).then(() => parcelRequire('gLzrJ'));